/** @format */
import React from 'react';

import { contentfulSrcSet } from './helpers';
import { ContentfulPictureProps } from './type';

export const ContentfulPicture = ({
    image,
    widths = undefined,
    className,
    ratio,
    options,
    'data-id': dataId = 'contentful-picture',
}: ContentfulPictureProps) => {
    const url = image?.url ?? image?.urlFallback;
    const contentType = image?.url
        ? image?.contentType
        : image?.contentTypeFallback;

    if (!url || !contentType) {
        return null;
    }

    // TODO: This has a bug, because we can manually set the aspect ratio
    // of the srcset. This needs to be updated so that either one
    // is used, but not both.
    const aspectRatio =
        image?.width && image?.height
            ? `${image?.width / image?.height}`
            : undefined;

    return (
        <picture
            className={className}
            data-testid="contentful-picture"
            data-id={dataId}
        >
            <source
                srcSet={contentfulSrcSet(url, 'webp', widths, ratio)}
                type="image/webp"
                data-id={`${dataId}__source--webp`}
            />
            <source
                srcSet={contentfulSrcSet(url, undefined, widths, ratio)}
                data-testid="contentful-picture-source"
                data-id={`${dataId}__source--${contentType}`}
                type={contentType}
            />
            <img
                src={url}
                alt={image?.description ?? ''}
                style={ratio ? undefined : { aspectRatio }}
                // @ts-ignore
                fetchpriority={options?.fetchPriority}
                data-id={`${dataId}__img`}
            />
        </picture>
    );
};
